(function () {
  function initAccordion(root) {
    if (!root || root.dataset.xoInit === "1") return;
    root.dataset.xoInit = "1";

    const items = Array.from(root.querySelectorAll(".xo-acc__item"));
    if (!items.length) return;

    function setOpen(btn, panel, open) {
      btn.setAttribute("aria-expanded", open ? "true" : "false");

      if (open) {
        panel.hidden = false;

        // Animate height (simple, reliable)
        panel.style.height = "auto";
        const h = panel.scrollHeight;
        panel.style.height = "0px";
        // force reflow
        panel.offsetHeight;
        panel.style.transition = "height 200ms ease";
        panel.style.height = h + "px";

        const onEnd = () => {
          panel.style.transition = "";
          panel.style.height = "auto";
          panel.removeEventListener("transitionend", onEnd);
        };
        panel.addEventListener("transitionend", onEnd);
      } else {
        if (panel.hidden) return;

        panel.style.height = panel.scrollHeight + "px";
        panel.offsetHeight;
        panel.style.transition = "height 200ms ease";
        panel.style.height = "0px";

        const onEnd = () => {
          panel.hidden = true;
          panel.style.transition = "";
          panel.style.height = "";
          panel.removeEventListener("transitionend", onEnd);
        };
        panel.addEventListener("transitionend", onEnd);
      }
    }

    items.forEach((item) => {
      const btn = item.querySelector(".xo-acc__button");
      if (!btn) return;

      const panelId = btn.getAttribute("aria-controls");
      const panel = panelId ? item.querySelector("#" + CSS.escape(panelId)) : null;
      if (!panel) return;

      // Ensure closed initial state
      btn.setAttribute("aria-expanded", "false");
      panel.hidden = true;

      btn.addEventListener("click", () => {
        const isOpen = btn.getAttribute("aria-expanded") === "true";
        setOpen(btn, panel, !isOpen);
      });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-xo-footer-accordion]").forEach(initAccordion);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();